// export const BaseURL="https://api.grabee.tech"
// export const BaseURL = "http://localhost:5000";

export const BaseURL="https://paycottserver.impulxor.com"

